var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg5Stars = function Svg5Stars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 24,
    viewBox: "0 0 136 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0L14.6942 8.2918H23.4127L16.3593 13.4164L19.0534 21.7082L12 16.5836L4.94658 21.7082L7.64074 13.4164L0.587322 8.2918H9.30583L12 0Z",
    fill: "#F8D22D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0L42.6942 8.2918H51.4127L44.3593 13.4164L47.0534 21.7082L40 16.5836L32.9466 21.7082L35.6407 13.4164L28.5873 8.2918H37.3058L40 0Z",
    fill: "#F8D22D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68 0L70.6942 8.2918H79.4127L72.3593 13.4164L75.0534 21.7082L68 16.5836L60.9466 21.7082L63.6407 13.4164L56.5873 8.2918H65.3058L68 0Z",
    fill: "#F8D22D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96 0L98.6942 8.2918H107.413L100.359 13.4164L103.053 21.7082L96 16.5836L88.9466 21.7082L91.6407 13.4164L84.5873 8.2918H93.3058L96 0Z",
    fill: "#F8D22D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124 0L126.694 8.2918H135.413L128.359 13.4164L131.053 21.7082L124 16.5836L116.947 21.7082L119.641 13.4164L112.587 8.2918H121.306L124 0Z",
    fill: "#F8D22D"
  })));
};
export default Svg5Stars;